import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';

@Component({
  name: 'bpc-suggested-articles',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class SuggestedArticles extends mixins(AbstractField) {
  @Prop([Object, Array]) readonly value: AnyEntity;

  public loading = false;

  public options: object[] = [];

  mounted() {
    if (!this.value) {
      this.model = {};
    } else {
      const resourceIds = Object.keys(this.model);
      const resources = resourceIds.map(id => {
        return { id: id };
      });
      this.getOptions(resources);
    }
  }

  get path(): string {
    return this.$bpcApiRouteHelper.getEntityPath('resources') + '/suggested-articles';
  }

  get model(): AnyEntity {
    return this.value;
  }
  set model(val: AnyEntity) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }
  updateModel() {
    this.$emit('input', this.value);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, this.value);
      });
    }
  }
  extendHandleEvent(eventName: string, event: any, val: any) {
    console.log('extend ' + eventName);
    this.getOptions(val);
  }
  public getOptions(val): void {
    if (val) {
      this.loading = true;
      let resourceIds = null;
      if (Array.isArray(val)) {
        resourceIds = val.map(v => {
          return v['id'];
        });
      } else {
        resourceIds = [val['id']];
      }
      this.$bpcApi.get(this.path, { params: { id: resourceIds } }).subscribe(
        (res: BPCGenericApiResponse) => {
          this.options = res.data;
          this.calculateModel();
        },
        error => {
          console.log(error);
        },
        () => {
          this.loading = false;
        },
      );
    }
  }
  public calculateModel() {
    const newModel = {};
    if (this.model) {
      Object.keys(this.model).forEach(key => {
        this.options.forEach(option => {
          if (option['resource']['id'] == key) {
            // == becouse I want that key is a string
            newModel[key] = this.model[key];
          }
        });
      });
    }
    this.model = newModel;
  }
  public thereIsArticles() {
    if (this.options) {
      const thereIs = false;
      for (const option of this.options) {
        if (option['articles'].length > 0) {
          return true;
        }
      }
    }
    return false;
  }
}
